import { Button, Stack, TableBody, TableCell, TableRow, Table, TableContainer } from '@mui/material'
import React, { useState } from 'react'

const ProductSpecification = ({ specs }) => {
    const [showAll, setShowAll] = useState(false);
    const disSpecs = showAll ? specs : specs.slice(0, 5);

    return (
        <>
            <TableContainer>
                <Table sx={{ width: 450, '& .MuiTableCell-root': { padding: '10px', }, borderSpacing: '1px 20px', }}>
                    <TableBody>
                        {(disSpecs || []).map((i, index) => (
                            <TableRow key={index} sx={{
                                border: '3px dotted rgba(0, 0, 0, 0.2)',
                                '&:nth-of-type(even)': { backgroundColor: 'rgba(217, 217, 217, 0.35)' },
                            }} >
                                <TableCell sx={{ fontSize: 14, fontWeight: 300 }}>{i.catSpec}</TableCell>
                                <TableCell sx={{ fontSize: 14, fontWeight: 300 }}>{i.value}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {specs.length > 5 && (
                <Button onClick={() => setShowAll(!showAll)} style={{ display: 'block', color: "rgba(53, 65, 236, 1)", textAlign: "left", fontSize: 12, fontWeight: 400 }}>{showAll ? 'Show Less' : 'Show All Specification'}</Button>
            )}
        </>
    )
}
export default ProductSpecification


